import { TChatModalOffer } from '../../types/chatModal';
import { ITypedReduxAction } from '../../types/redux';

export enum EChatModalActionType {
  Open = 'chatModal/open',
  OpenAfterAuth = 'chatModal/openAfterAuth',
  Close = 'chatModal/close',
}

export interface IOpenChatModalPayload {
  gaLabel: string;
  offer: TChatModalOffer;
  defaultMessage?: string;
}

export interface IOpenChatModalAfterAuthPayload {
  gaLabel: string;
  offer: TChatModalOffer;
  defaultMessage?: string;
}

export type TChatModalOpen = ITypedReduxAction<EChatModalActionType.Open, IOpenChatModalPayload>;
export type TChatModalOpenAfterAuth = ITypedReduxAction<
  EChatModalActionType.OpenAfterAuth,
  IOpenChatModalAfterAuthPayload
>;
export type TChatModalClose = ITypedReduxAction<EChatModalActionType.Close>;

export type TChatModalActions = TChatModalOpen | TChatModalClose | TChatModalOpenAfterAuth;
